import React from "react"
import icon from "images/logo-ifttt-white.svg"

export default function IftttLogoIcon() {
  return (
    <span className="svg-icon" dangerouslySetInnerHTML={{ __html: icon }} />
  )
}
